import { render, staticRenderFns } from "./Podcasts.vue?vue&type=template&id=cb5e9f00&scoped=true&"
import script from "./Podcasts.vue?vue&type=script&lang=js&"
export * from "./Podcasts.vue?vue&type=script&lang=js&"
import style0 from "./Podcasts.vue?vue&type=style&index=0&id=cb5e9f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5e9f00",
  null
  
)

export default component.exports